import React from 'react';
import { Table as TableIcon } from 'lucide-react';

const TableMockup: React.FC = () => {
  return (
    <div className="bg-gray-50 rounded-2xl p-5 h-[380px] flex flex-col shadow-lg">
      {/* Header */}
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-xl font-bold text-gray-800">Product Inventory</h3>
        <div className="flex items-center gap-2">
          <button className="h-8 px-3 rounded-full text-xs font-medium bg-white text-gray-700 border border-gray-300 shadow-sm flex items-center gap-1">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="12" y1="5" x2="12" y2="19"></line>
              <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
            Add Item
          </button>
          <button className="h-8 w-8 rounded-full flex items-center justify-center text-gray-700 border border-gray-300 bg-white shadow-sm">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="1"></circle>
              <circle cx="19" cy="12" r="1"></circle>
              <circle cx="5" cy="12" r="1"></circle>
            </svg>
          </button>
        </div>
      </div>

      {/* Table Content */}
      <div className="flex-1 overflow-y-auto overflow-x-auto">
        <table className="w-full border-collapse">
          <thead>
            <tr className="border-b border-gray-200">
              <th className="py-3 px-4 text-left text-xs font-semibold text-gray-600 bg-gray-100 sticky top-0">
                <div className="flex items-center gap-1">
                  Item
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="6 9 12 15 18 9"></polyline>
                  </svg>
                </div>
              </th>
              <th className="py-3 px-4 text-left text-xs font-semibold text-gray-600 bg-gray-100 sticky top-0">
                <div className="flex items-center gap-1">
                  Stock
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="6 9 12 15 18 9"></polyline>
                  </svg>
                </div>
              </th>
              <th className="py-3 px-4 text-left text-xs font-semibold text-gray-600 bg-gray-100 sticky top-0">
                <div className="flex items-center gap-1">
                  Price
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="6 9 12 15 18 9"></polyline>
                  </svg>
                </div>
              </th>
              <th className="py-3 px-4 text-left text-xs font-semibold text-gray-600 bg-gray-100 sticky top-0">
                <div className="flex items-center gap-1">
                  Category
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="6 9 12 15 18 9"></polyline>
                  </svg>
                </div>
              </th>
              <th className="py-3 px-4 text-left text-xs font-semibold text-gray-600 bg-gray-100 sticky top-0">
                <div className="flex items-center gap-1">
                  Status
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="6 9 12 15 18 9"></polyline>
                  </svg>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className="border-b border-gray-200 hover:bg-gray-50">
              <td className="py-3 px-4 text-sm text-gray-800">Wireless Headphones</td>
              <td className="py-3 px-4 text-sm text-gray-600">24</td>
              <td className="py-3 px-4 text-sm text-gray-600">$89.99</td>
              <td className="py-3 px-4">
                <div className="flex items-center">
                  <div className="w-2 h-2 rounded-full bg-blue-500 mr-2"></div>
                  <span className="text-sm text-gray-600">Electronics</span>
                </div>
              </td>
              <td className="py-3 px-4">
                <span className="px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                  Ok
                </span>
              </td>
            </tr>
            <tr className="border-b border-gray-200 hover:bg-gray-50">
              <td className="py-3 px-4 text-sm text-gray-800">Smart Watch</td>
              <td className="py-3 px-4 text-sm text-gray-600">12</td>
              <td className="py-3 px-4 text-sm text-gray-600">$249.99</td>
              <td className="py-3 px-4">
                <div className="flex items-center">
                  <div className="w-2 h-2 rounded-full bg-blue-500 mr-2"></div>
                  <span className="text-sm text-gray-600">Electronics</span>
                </div>
              </td>
              <td className="py-3 px-4">
                <span className="px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                  Ok
                </span>
              </td>
            </tr>
            <tr className="border-b border-gray-200 hover:bg-gray-50">
              <td className="py-3 px-4 text-sm text-gray-800">Desk Lamp</td>
              <td className="py-3 px-4 text-sm text-gray-600">8</td>
              <td className="py-3 px-4 text-sm text-gray-600">$34.50</td>
              <td className="py-3 px-4">
                <div className="flex items-center">
                  <div className="w-2 h-2 rounded-full bg-yellow-500 mr-2"></div>
                  <span className="text-sm text-gray-600">Home</span>
                </div>
              </td>
              <td className="py-3 px-4">
                <span className="px-2 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
                  Low
                </span>
              </td>
            </tr>
            <tr className="border-b border-gray-200 hover:bg-gray-50">
              <td className="py-3 px-4 text-sm text-gray-800">Canvas Backpack</td>
              <td className="py-3 px-4 text-sm text-gray-600">32</td>
              <td className="py-3 px-4 text-sm text-gray-600">$59.95</td>
              <td className="py-3 px-4">
                <div className="flex items-center">
                  <div className="w-2 h-2 rounded-full bg-green-500 mr-2"></div>
                  <span className="text-sm text-gray-600">Accessories</span>
                </div>
              </td>
              <td className="py-3 px-4">
                <span className="px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                  Ok
                </span>
              </td>
            </tr>
            <tr className="border-b border-gray-200 hover:bg-gray-50">
              <td className="py-3 px-4 text-sm text-gray-800">Coffee Maker</td>
              <td className="py-3 px-4 text-sm text-gray-600">0</td>
              <td className="py-3 px-4 text-sm text-gray-600">$129.99</td>
              <td className="py-3 px-4">
                <div className="flex items-center">
                  <div className="w-2 h-2 rounded-full bg-yellow-500 mr-2"></div>
                  <span className="text-sm text-gray-600">Home</span>
                </div>
              </td>
              <td className="py-3 px-4">
                <span className="px-2 py-1 rounded-full text-xs font-medium bg-red-100 text-red-800">
                  Out
                </span>
              </td>
            </tr>
            <tr className="border-b border-gray-200 hover:bg-gray-50">
              <td className="py-3 px-4 text-sm text-gray-800">Bluetooth Speaker</td>
              <td className="py-3 px-4 text-sm text-gray-600">15</td>
              <td className="py-3 px-4 text-sm text-gray-600">$79.99</td>
              <td className="py-3 px-4">
                <div className="flex items-center">
                  <div className="w-2 h-2 rounded-full bg-blue-500 mr-2"></div>
                  <span className="text-sm text-gray-600">Electronics</span>
                </div>
              </td>
              <td className="py-3 px-4">
                <span className="px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                  Ok
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export const tableMockupData = {
  type: 'Table',
  icon: TableIcon,
  description:
    'Organize and analyze structured data with flexible tables. Create custom columns with different data types, sort and filter information, and build powerful dashboards to track anything from content calendars to product inventories.',
  mockup: <TableMockup />
};

export default TableMockup;